import { URLS } from 'constants/urls'
import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from 'redux/hooks'
import { authIsLoadedSelector, isOperatorSelector } from 'redux/login/selectors'

interface IProtectRouteProps {
  children?: ReactNode | null
  isUnavailable?: boolean
}

export const ProtectedRoute = ({
  children,
  isUnavailable,
}: IProtectRouteProps) => {
  const isLoaded = useAppSelector(authIsLoadedSelector)
  const { state } = useLocation()
  const isOperator = useAppSelector(isOperatorSelector)

  if (!isLoaded) {
    return null
  }

  if (isUnavailable) {
    if (state?.companyId) {
      return (
        <Navigate
          to={`${URLS.PROFILE}${URLS.PROFILE_LIST}/${state.companyId}/edit`}
        />
      )
    }

    return (
      <Navigate
        to={isOperator ? URLS.PROFILE + URLS.PROFILE_LIST : URLS.DASHBOARD}
      />
    )
  }

  return <>{children}</>
}
